module.exports = __webpack_public_path__ + "fepro/img/history.697b1f66.png";